<div class="xl-custom-consensus">
  <div class="header">
    <span class="title">Custom Consensus</span>
  </div>

  <nz-input-group class="ticker-select-wrapper" [nzPrefix]="prefixIcon">
    <nz-select
      class="ticker-select"
      nzShowSearch
      style="width: 100%;"
      [(ngModel)]="selectedTicker"
      (ngModelChange)="tickerSelected()"
      nzPlaceHolder="Search Company or Ticker"
      (nzOnSearch)="onTickerSearchEdit($event)"
      nzServerSearch
      [nzCustomTemplate]="custom"
      [nzShowArrow]="false"
    >
      <nz-option
        *ngFor="let ticker of tickers"
        [nzLabel]="ticker.sn + ': ' + ticker.n"
        [nzValue]="ticker.sn"
      ></nz-option>
      <nz-option nzHide nzLabel="dummy" nzValue="dummy"></nz-option>
      <nz-option *ngIf="noData" nzDisabled nzCustomContent>
        {{ noData }}
      </nz-option>
    </nz-select>
    <ng-template #custom let-selected>
      <span>{{ selected.nzValue }}</span>
    </ng-template>
  </nz-input-group>

  <app-custom-consensus-core
    *ngIf="selectedTicker"
    [ccVars]="ccVars"
    [note]="note"
    [showHideBrokerCheckbox]="false"
    (onSave)="handleSave($event)"
    (onCancel)="handleCancel()"
    (ngModelChange)="ccDataChanged($event)"
  >
  </app-custom-consensus-core>
  <div *ngIf="!selectedTicker" class="xlfooter">
    <div *ngIf="note" class="note">{{ note }}</div>
    <div class="action-btns">
      <button
        class="xlbtn-secondary"
        nz-button
        nzType="link"
        (click)="handleCancel()"
      >
        Cancel
      </button>
      <button
        nz-button
        nzType="link"
        class="xlbtn-primary"
        [class.disabled]="true"
      >
        Save
      </button>
    </div>
  </div>
</div>
<ng-template #prefixIcon
  ><va-icon name="search" class="fal fa-md" style="color: #222222"></va-icon
></ng-template>
